import {
  ADMINISTRATOR_TYPE_ID,
  getViewerEmailFromStorage,
  loadUserMatrixSettings,
  findMatrixUser,
} from "./userMatrixStorage";
import { isPermittingRoleName } from "./projectLandingTabAccess";

function readImpersonationRoleType(settings) {
  try {
    const raw = localStorage.getItem("pb.userImpersonation.v1");
    if (!raw) return null;
    const j = JSON.parse(raw);
    if (!j?.userTypeId) return null;
    return settings.userTypes.find((t) => t.id === j.userTypeId) || null;
  } catch {
    return null;
  }
}

function resolveViewerRoleType(viewerEmail) {
  const settings = loadUserMatrixSettings();
  const imp = readImpersonationRoleType(settings);
  if (imp) return imp;

  const email = String(viewerEmail || getViewerEmailFromStorage() || "")
    .trim()
    .toLowerCase();
  if (!email) return null;
  const user = findMatrixUser(settings.users, email);
  if (!user) return null;
  return settings.userTypes.find((t) => t.id === user.userTypeId) || null;
}

/** Administrator, Coordinator, Permitting roles, or role name containing "Manager". */
export function roleCanUsePortfolioAi(roleType) {
  if (!roleType) return false;
  if (roleType.id === ADMINISTRATOR_TYPE_ID) return true;
  const name = String(roleType.name || "").trim().toLowerCase();
  if (name === "coordinator") return true;
  if (isPermittingRoleName(roleType.name)) return true;
  if (name.includes("manager")) return true;
  return false;
}

export function canUsePortfolioAi(viewerEmail) {
  return roleCanUsePortfolioAi(resolveViewerRoleType(viewerEmail));
}
